export function useTrialPicker(isPaidHub, isProOrEntTrial, scopes) {
  const showStartTrialButton = isPaidHub && !isProOrEntTrial && scopes && scopes.includes('trials-starter-product');
  return [showStartTrialButton];
}